import React, { memo } from 'react';
import { Form } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import CustomInput from '.';
import CustomTooltip from '../toolTip';

import { INPUT_TYPES } from '../../constants/componentTypes';

const FormInput = ({
  label,
  name,
  rules = [],
  type = INPUT_TYPES.TEXT,
  placeholder = '',
  value,
  onChange,
  icon,
  tooltipText,
  options = [],
  dependencies = [],
  disabled = false,
  className = '',
  searchable = false,
  ...props
}) => {
  const renderLabel = tooltipText ? (
    <>
      {label}
      <CustomTooltip title={tooltipText} placement='topLeft' className='bookroad-tooltip'>
        <InfoCircleOutlined className='ml-8 input-info-icon' />
      </CustomTooltip>
    </>
  ) : (
    label
  );

  return (
    <Form.Item
      label={renderLabel}
      name={name}
      rules={rules}
      dependencies={dependencies}
      className={`custom-form-input ${className}`}
    >
      <CustomInput
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        icon={icon}
        options={options}
        disabled={disabled}
        searchable={searchable}
        {...props}
      />
    </Form.Item>
  );
};

export default memo(FormInput);

FormInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.array,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  icon: PropTypes.string,
  tooltipText: PropTypes.string,
  dependencies: PropTypes.array,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
